import React from 'react';
import type { ReactNode } from 'react';

import { Box, Container } from '@mui/material';

export type RootLayoutProps = {
  children: ReactNode
};

const RootLayout = ({ children }: RootLayoutProps) => (
  <Container disableGutters maxWidth={false}>
    <Box sx={{ flexGrow: 1 }}>{children}</Box>
  </Container>
);

export default RootLayout;
